import { render, staticRenderFns } from "./ModalFinalizacaoAcolhimento.vue?vue&type=template&id=12959837"
import script from "./ModalFinalizacaoAcolhimento.vue?vue&type=script&lang=js"
export * from "./ModalFinalizacaoAcolhimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports